import API from "../../../../../global/api";
// import jsPDF from "jspdf";
// import moment from "moment";
// import { isEmpty } from "lodash";
// import { PDFHeader } from "../../../../../global/globalFunctions";


export const requestAddExpense = () => {
    return {
        type: "REQUEST_ADD_EXPENSE",
    };
};
export const successAddExpense = (data) => {
    return {
        type: "SUCCESS_ADD_EXPENSE",
        payload: data,
    };
};
export const errorAddExpense = () => {
    return {
        type: "ERROR_ADD_EXPENSE",
    };
};
export const AddExpenseApi = (payload, showSuccessAlert, showErrorAlert) => {
    return (dispatch) => {
        dispatch(requestAddExpense());
        API.post(`/construction/update-order-expense`, payload)
            .then((res) => {
                dispatch(successAddExpense(payload));
                showSuccessAlert(res.data.message);
            }).catch((error) => {
                dispatch(errorAddExpense());
                showErrorAlert(error.response.data.message || "Something went wrong");
            });
    };
};


export const requestGetExpenseByOrderCategory = () => {
    return {
        type: "REQUEST_GET_EXPENSE_BY_ORDER_CATEGORY",
    };
};
export const successGetExpenseByOrderCategory = (response) => {
    return {
        type: "SUCCESS_GET_EXPENSE_BY_ORDER_CATEGORY",
        payload: response,
    };
};
export const errorGetExpenseByOrderCategory = () => {
    return {
        type: "ERROR_GET_EXPENSE_BY_ORDER_CATEGORY",
    };
};
export const GetExpenseByOrderCategoryApi = (orderId, categoryId) => {
    return (dispatch) => {
        dispatch(requestGetExpenseByOrderCategory());
        API.post(`/construction/get-order-expense-with-category`, { orderId, categoryId })
            .then((res) => {
                let response = res.data;
                dispatch(successGetExpenseByOrderCategory(response));
            }).catch((error) => {
                dispatch(errorGetExpenseByOrderCategory());
            });
    };
};